import {
  CatalogueVendor
} from '../models';

export const mapCatalogueVendor = (result) => {

  return new CatalogueVendor(result).mapToStandard();
};